var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcWc = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 23",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.28 8.463h8.792v1.215H6.28zm8.913 2.542H0v11h7.58c0-1.215.215-2.548 1.277-3.296.876-.617 1.988-.66 2.991-.928a5.5 5.5 0 0 0 2.499-1.474c1.38-1.423 1.787-3.525.846-5.302M0 0h5.139v9.686H0z"
})));
export default SvgIcWc;